import React from 'react';
import _ from 'lodash';
import Subheader from 'src/components/Subheader/Subheader.container';
import { SubheaderSlice } from 'src/components/Subheader/Subheader.slice';
import { TenantConfigViewItem, TenantConfigViewData } from 'src/dao/tenantConfigClient';
import { styles, chartContainer } from './ProductMix.styles';
import { BasicPivotItem } from 'src/worker/pivotWorker.types';
import { Overlay } from 'src/common-ui';
import { ViewConfiguratorModalProps } from 'src/components/ViewConfiguratorModal/ViewConfiguratorModal';
import { ViewDataState } from 'src/types/Domain';
import { Options, Point, PointLegendItemClickEventObject } from 'highcharts';
import { PieRender } from './PieRender';
import { ChartRender } from './ChartRender';

export const baseConfig: Options = {
  chart: {
    plotBackgroundColor: undefined,
    plotBorderWidth: 0,
    plotShadow: false,
    marginTop: 10,
  },
  title: {
    text: '',
    margin: 4,
    align: 'center',
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
        distance: -70,
        style: {
          fontWeight: 'bold',
          color: 'white',
        },
      },
      startAngle: 0,
      endAngle: 360,
      size: '93%',
      center: ['50%', '75%'],
      point: {
        events: {
          legendItemClick: function (this: Point, event: PointLegendItemClickEventObject) {
            event.preventDefault();
          },
        },
      },
    },
  },
  credits: {
    enabled: false,
  },
  series: [],
};

type SubheaderPicks = 'groupBy' | 'flowStatus';

export interface ValueProps extends Pick<SubheaderSlice, SubheaderPicks> {
  title: string;
  loaded: boolean;
  pieChartView?: TenantConfigViewItem;
  barChartView?: TenantConfigViewItem;
  data: BasicPivotItem[] | null;
  totals: BasicPivotItem | null;
  groupByViewDefnStr?: string;
  viewDefn: TenantConfigViewData;
  viewDataState: ViewDataState;
}

export interface FunctionProps {
  onShowView(): void;
}

interface Props extends FunctionProps, ValueProps {
  isPrintMode: boolean;
  printWidth: string;
}

export class ProductMix extends React.Component<Props> {
  reloadData: () => void = () => null;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    this.props.onShowView();
  }

  render() {
    const {
      title,
      data,
      totals,
      pieChartView,
      barChartView,
      groupByViewDefnStr,
      loaded,
      viewDefn,
      viewDataState,
      isPrintMode,
      printWidth,
    } = this.props;

    let pieJsx, barJsx;

    if (!_.isNil(pieChartView) && !_.isNil(barChartView) && !_.isNil(data) && !_.isNil(totals)) {
      pieJsx = (
        <React.Fragment>
          <header className={styles.sectionHeader}>{pieChartView.text}</header>
          <div className={styles.sectionBody}>
            <PieRender {...{ data, totals, view: pieChartView, config: baseConfig, isPrintMode, printWidth }} />
          </div>
        </React.Fragment>
      );
      barJsx = (
        <React.Fragment>
          <header className={styles.sectionHeader}>{barChartView.text}</header>
          <div className={styles.sectionBody} style={{ display: 'flex' }}>
            <ChartRender {...{ data, totals, view: barChartView, config: baseConfig, isPrintMode, printWidth }} />
          </div>
        </React.Fragment>
      );
    }

    const viewConfigurator: ViewConfiguratorModalProps = {
      viewConfig: viewDefn,
      unmodifiedViewDefn: viewDefn,
    };

    return (
      <div style={{ height: '100%', width: '100%', zIndex: 'auto', overflow: 'hidden', position: 'relative' }}>
        <Subheader
          title={title}
          groupByDefn={groupByViewDefnStr}
          showFlowStatus={true}
          showSearch={false}
          viewConfigurator={viewConfigurator}
          viewDataState={viewDataState}
        />
        {!loaded && <Overlay type={'loading'} visible={true} />}
        {loaded && (
          <div className={chartContainer}>
            <React.Fragment>
              <div className={styles.section}>{pieJsx}</div>
              <div className={styles.section}>{barJsx}</div>
            </React.Fragment>
          </div>
        )}
      </div>
    );
  }
}
